import { AppContextSystemPermissionType } from './permissionUtils';

export const useSystemPermission = (systemPermissionCode: AppContextSystemPermissionType): boolean => true;
